<script setup lang="ts">
import Navbar from "@/components/landing/Navbar.vue";
import Footer from "@/components/landing/Footer.vue";
import { useRoute } from "vue-router";
import { computed } from "vue";

const route = useRoute();
const Key = computed(() => route.fullPath);
</script>

<template>
  <Navbar />
  <router-view :key="Key" />
  <Footer />
</template>
